import { equals, props, unionWith } from 'ramda';
import { handleActions } from 'redux-actions';

import * as types from './actionTypes';

const initialState = {
	edk: [],
	idk: [],
};

const merge = (storeRegions, fetchedRegions) => {
	const compare = props(['channelId', 'id']);
	return unionWith((s, f) => equals(compare(s), compare(f)), storeRegions, fetchedRegions);
};

const reducerMap = {
	[types.FETCH_REGION_SUCCESS]: (state, { payload }) => ({
		...state,
		idk: merge(state.idk, payload.regions),
	}),
	[types.FETCH_EDK_REGION_SUCCESS]: (state, { payload }) => ({
		...state,
		edk: payload.regions,
	}),
};

export default handleActions(reducerMap, initialState);
